import { constants } from '../../helpers';
import {
  changeCollectionsFilterEndBusinessDate,
  changeCollectionsFilterStartBusinessDate,
  reportCollectionsFilterEndBusinessDateSelector,
  reportCollectionsFilterStartBusinessDateSelector,
} from '../../state';
import { DateRangeFlexSalesProps } from '../DateRangeFlexSales';
import ReportBusinessDateRangeFilter from '../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const BusinessDateRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter
    {...props}
    maxDate={constants.reportCollectionsFilterRangeMaxDate}
    startDateSelector={reportCollectionsFilterStartBusinessDateSelector}
    endDateSelector={reportCollectionsFilterEndBusinessDateSelector}
    changeStartDateAction={changeCollectionsFilterStartBusinessDate}
    changeEndDateAction={changeCollectionsFilterEndBusinessDate}
  />
);

export default BusinessDateRangeFilter;
